import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-intl-redux';
import { addLocaleData } from 'react-intl';
import moment from 'moment';

import 'moment/locale/vi';
import viLocaleData from 'react-intl/locale-data/vi';

import 'moment/locale/en-gb';
import enLocaleData from 'react-intl/locale-data/en';

import {switchLanguage} from './actions/intl'

import './App.less';

import LocaleProvider from './locales/LocaleProvider';
import MainLayout from './layouts/MainLayout';
import { routes, privateRoutes, PrivateRoute } from './routes';
import store, { persistor } from './store';

import {loadJson} from './utils/loadjson';
const homeLayout = loadJson( '/assets/home.json');
const initLang = homeLayout.initLang;

const queryParams = new URLSearchParams(window.location.search);
const lang = queryParams.get('lang');


let startLang;

if ( lang !== '') {
  startLang =  lang;
} else if ( initLang !== '' ) {
  startLang =  initLang;
} else {
  startLang =  'vi';
}

addLocaleData([
  ...enLocaleData,
  ...viLocaleData,
]);

moment.locale(startLang);
switchLanguage(startLang);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocaleProvider>
            <Router>
              <MainLayout>
                <Switch>
                  {routes.map(route => (
                    <Route
                      key={route.key}
                      path={route.path}
                      exact={route.exact}
                      component={route.component}
                    />))}
                  {privateRoutes.map(route => (
                    <PrivateRoute
                      key={route.key}
                      path={route.path}
                      exact={route.exact}
                      component={route.component}
                      isRedirect={route.isRedirect}
                      redirect={route.redirect}
                    />))}
                </Switch>
              </MainLayout>
            </Router>
          </LocaleProvider>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js